var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1202_13931",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H17.9377V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1202_13931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.05 13.8152L8.96981 21.721L2.88962 13.8152C1.90204 12.4705 1.37999 10.869 1.37999 9.18382C1.37999 6.72138 2.54476 4.37594 4.49578 2.90997C6.46464 1.43055 8.98227 1.02035 11.403 1.78441C13.6449 2.49213 15.4767 4.37758 16.1835 6.70488C16.9436 9.20805 16.5304 11.7993 15.05 13.8152M17.5017 6.28896C16.6623 3.52464 14.4818 1.28383 11.8111 0.440737C8.96724 -0.456966 6.00242 0.0303463 3.67688 1.77771C2.56261 2.61499 1.63798 3.71927 1.00308 4.97116C0.346838 6.26505 0 7.72174 0 9.18382C0 11.1783 0.618945 13.0736 1.78997 14.665L8.96981 24L16.1407 14.6769L16.1497 14.665C17.9021 12.2833 18.3949 9.23031 17.5017 6.28896",
    fill: "#A31265"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99084 12.5714C7.02364 12.5714 5.42315 10.9693 5.42315 8.99995C5.42315 7.03073 7.02359 5.4285 8.99084 5.4285C10.9581 5.4285 12.5585 7.03068 12.5585 8.99995C12.5585 10.9693 10.9581 12.5714 8.99084 12.5714M8.99084 4C6.23675 4 3.99609 6.24297 3.99609 8.99995C3.99609 11.757 6.23675 14 8.99084 14C11.7449 14 13.9856 11.757 13.9856 8.99995C13.9856 6.24297 11.7449 4 8.99084 4",
    fill: "#A31265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bfe666039c6bec920954d2e54b5851a6.svg";
export { ForwardRef as ReactComponent };